/* eslint-disable no-inline-comments */
/* eslint-disable capitalized-comments */
// ========================= IMPORT DEPENDENCIES ========================= //

import { bootstrap } from '@mvps-genesis/bootstrap';
import Global from 'pages/Global';

// ========================= RUN MAIN SCRIPT ========================= //

bootstrap({

	// Pass your MVT to JS namespace
	context: window.mivaJS,

	// Global Page class
	globalClass: Global,

	// A directory of page classes or scss files to be loaded by matching the `Page_Code` context variable
	pageCodeImports: {
		ABAL: () => import(/* webpackChunkName: "page-code--ABAL" */'pages/ABAL/ABAL.js'),
		ACAD: () => import(/* webpackChunkName: "page-code--ACAD" */'pages/ACAD/ACAD.js'),
		ACED: () => import(/* webpackChunkName: "page-code--ACED" */'pages/ACED/ACED.js'),
		ACLN: () => import(/* webpackChunkName: "page-code--ACLN" */'pages/ACLN/ACLN.js'),
		AFAD: () => import(/* webpackChunkName: "page-code--AFAD" */'pages/AFAD/AFAD.js'),
		AFED: () => import(/* webpackChunkName: "page-code--AFED" */'pages/AFED/AFED.js'),
		BASK: () => import(/* webpackChunkName: "page-code--BASK" */'pages/BASK/BASK.js'),
		CABK: () => import(/* webpackChunkName: "page-code--CABK" */'pages/CABK/CABK.js'),
		CADA: () => import(/* webpackChunkName: "page-code--CADA" */'pages/CADA/CADA.js'),
		CADE: () => import(/* webpackChunkName: "page-code--CADE" */'pages/CADE/CADE.js'),
		CEML: () => import(/* webpackChunkName: "page-code--CEML" */'pages/CEML/CEML.js'),
		CPCA: () => import(/* webpackChunkName: "page-code--CPCA" */'pages/CPCA/CPCA.js'),
		CPCD: () => import(/* webpackChunkName: "page-code--CPCD" */'pages/CPCD/CPCD.js'),
		CPCE: () => import(/* webpackChunkName: "page-code--CPCE" */'pages/CPCE/CPCE.js'),
		CPWD: () => import(/* webpackChunkName: "page-code--CPWD" */'pages/CPWD/CPWD.js'),
		CSBE: () => import(/* webpackChunkName: "page-code--CSBE" */'pages/CSBE/CSBE.js'),
		CSTR: () => import(/* webpackChunkName: "page-code--CSTR" */'pages/CSTR/CSTR.js'),
		CSUB: () => import(/* webpackChunkName: "page-code--CSUB" */'pages/CSUB/CSUB.js'),
		CTUS: () => import(/* webpackChunkName: "page-code--CTUS" */'pages/CTUS/CTUS.js'),
		GFTL: () => import(/* webpackChunkName: "page-code--GFTL" */'pages/GFTL/GFTL.js'),
		INVC: () => import(/* webpackChunkName: "page-code--INVC" */'pages/INVC/INVC.js'),
		LOGN: () => import(/* webpackChunkName: "page-code--LOGN" */'pages/LOGN/LOGN.js'),
		NTFD: () => import(/* webpackChunkName: "page-code--NTFD" */'pages/NTFD/NTFD.js'),
		OCST: () => import(/* webpackChunkName: "page-code--OCST" */'pages/OCST/OCST.js'),
		OPAY: () => import(/* webpackChunkName: "page-code--OPAY" */'pages/OPAY/OPAY.js'),
		ORDH: () => import(/* webpackChunkName: "page-code--ORDH" */'pages/ORDH/ORDH.js'),
		ORDL: () => import(/* webpackChunkName: "page-code--ORDL" */'pages/ORDL/ORDL.js'),
		ORDS: () => import(/* webpackChunkName: "page-code--ORDS" */'pages/ORDS/ORDS.js'),
		ORHL: () => import(/* webpackChunkName: "page-code--ORHL" */'pages/ORHL/ORHL.js'),
		OSEL: () => import(/* webpackChunkName: "page-code--OSEL" */'pages/OSEL/OSEL.js'),
		RGFT: () => import(/* webpackChunkName: "page-code--RGFT" */'pages/RGFT/RGFT.js'),
		SFNT: () => import(/* webpackChunkName: "page-code--RGFT" */'pages/SFNT/SFNT.js'),
		SRCH: () => import(/* webpackChunkName: "page-code--SRCH" */'pages/SRCH/SRCH.js'),
		WISH: () => import(/* webpackChunkName: "page-code--WISH" */'pages/WISH/WISH.js'),
		WLAD: () => import(/* webpackChunkName: "page-code--WLAD" */'pages/WLAD/WLAD.js'),
		WLED: () => import(/* webpackChunkName: "page-code--WLED" */'pages/WLED/WLED.js'),
		WLGN: () => import(/* webpackChunkName: "page-code--WLGN" */'pages/WLGN/WLGN.js'),
		CDEA: () => import(/* webpackChunkName: "page-code--CDEA" */'pages/CDEA/CDEA.js'),
		BLOG: () => import(/* webpackChunkName: "page-code--BLOG" */'pages/BLOG/BLOG.js'),
		CTGY: () => import(/* webpackChunkName: "page-code--CTGY" */'pages/CTGY/CTGY.js'),
		WLST: () => import(/* webpackChunkName: "page-code--WLST" */'pages/WLST/WLST.js'),
		WPCK: () => import(/* webpackChunkName: "page-code--WPCK" */'pages/WPCK/WPCK.js')
	},

	// A directory of page classes or scss files to be loaded by matching the `Screen` or `Page_Code` context variable against a regular expression
	regexImports: {},

	// A directory of page classes or scss files to be loaded by matching the `Screen` context variable
	screenImports: {
		PROD: () => import(/* webpackChunkName: "page-code--PROD" */'pages/PROD/PROD.js')
	}

});
